import { Divider, Layout } from 'antd';
import * as React from "react";
import { IconContext } from "react-icons";
import { MdRefresh } from 'react-icons/md';
import MediaQuery from 'react-responsive';
import { RouteComponentProps } from "react-router-dom";
import { SiderComponent } from "../layout/SiderComponent";
import { SortTabsComponent } from "../layout/SortTabsComponent";
import { PostListConnector } from "../post/list/PostListConnector";


const { Content } = Layout;

export class HomePageComponet extends React.PureComponent<RouteComponentProps<{}>> {
  refetch: () => void;
  assignRefetch = (fetch: () => void) => this.refetch = fetch;

  renderRefreshComponent = () => (
    <div>
      <MediaQuery minWidth={800}>
        <div onClick={() => this.refetch()} style={{ marginBottom: 20, marginTop: 10, cursor: 'pointer' }}>
          <IconContext.Provider value={{ size: "1.5em", style: { verticalAlign: 'middle' } }}>
            <span>Click to <MdRefresh /> Or use browser refresh</span>
          </IconContext.Provider>
        </div>
      </MediaQuery>
    </div>
  )

  render() {
    return (
      <Content>
        <Layout style={{ background: '#fff', marginLeft: 20 }}>
          <MediaQuery minWidth={650}>
            <SiderComponent />
          </MediaQuery>
          <Divider type="vertical" style={{ height: 'auto' }} />
          <Layout style={{ background: '#fff', marginLeft: 20, marginRight: 20 }}>
            <SortTabsComponent renderRefresh={this.renderRefreshComponent} />
            <PostListConnector assignRefetch={this.assignRefetch} />
          </Layout>
        </Layout>
      </Content>
    );
  }
}




// WEBPACK FOOTER //
// ./src/modules/screen/HomePageComponent.tsx